module.exports = __webpack_public_path__ + "static/media/Pixel1_FR.png?v=e2f67c84";